export { ReactComponent as PendingSvg } from '@/assets/imgs/pending.svg'
export { ReactComponent as WaitSvg } from '@/assets/imgs/account/wait.svg'
export { ReactComponent as CompleteSvg } from '@/assets/imgs/account/complete.svg'
